<div class="row mt-3" *ngIf="hasQuotes">
  <div class="col-sm-12">
    <tan-table [columnConfig]="columnConfig" [data]="quotes" [loading]="(quotesLoading$ | async)"
      [error]="(quotesError$ | async)" [actionButtons]="actionButtons" [hasActionCol]="true" [canSearch]="canSearch"
      [hasActionColEdit]="hasActionColEdit" [hasActionColDuplicate]="hasActionColDuplicate"
      [filterConfigItems]="filterDropdownOptions" [iconClass]="iconClass" [totalPages]="pageCount"
      [itemCount]="itemCount" [currentPage]="currentPage" (onPageClick)="paginate($event)"
      (onClickViewItem)="viewItem($event)" (onClickEditItem)="editItem($event)"
      (onClickDuplicateItem)="duplicateItem($event)" (onClickRetry)="retry()" [canBulkEdit]="false" [page]="'quotes'"
      (onActionClick)="actionClickEvent($event)" (searchTerm)="search($event)" (onFilter)="filter($event)"
      (onClickSort)="sort($event)"></tan-table>
  </div>
</div>

<tan-modal #editCustomerQuoteModal [size]="'md'" [title]="'Edit Quote'" [showInformationBlock]="false"
  (onSave)="saveUpdateQuote()">
  <div modal-content>
    <div class="container">
      <tan-loader [loading]="(updateQuoteLoading$ | async)" [loadingText]="'<p>Updating Quote</p>'">
      </tan-loader>

      <div class="row justify-content-center" *ngIf="(updateQuoteError$ | async)">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Could not update Quote'"></tan-alert-message>
        </div>
      </div>

      <div class="row" *ngIf="!(updateQuoteError$ | async) && !(updateQuoteLoading$ | async)">
        <div class="col-sm-12">
          <div class="">
            <form class="mt-3" [formGroup]="editQuoteForm">

              <div class="form-group">
                <label class="control-label" for="quote_status">Status</label>
                <select class="form-control" formControlName="quote_status" id="quote_status"
                  (change)="setQuoteStatus()" [attr.disabled]="!canEditStatus ? 'disabled' : null">
                  <option [ngValue]="null">Please select</option>
                  <option *ngFor="let status of quoteStatusCustomer" [ngValue]="status.id">{{ status.name }}</option>
                </select>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal #editQuoteModal [size]="'md'" [title]="'Edit Quote'" [showInformationBlock]="false"
  (onSave)="saveUpdateQuote()">
  <div modal-content>
    <div class="container">
      <tan-loader [loading]="(updateQuoteLoading$ | async)" [loadingText]="'<p>Updating Quote</p>'">
      </tan-loader>

      <div class="row justify-content-center" *ngIf="(updateQuoteError$ | async)">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Could not update Quote'"></tan-alert-message>
        </div>
      </div>

      <div class="row" *ngIf="!(updateQuoteError$ | async) && !(updateQuoteLoading$ | async)">
        <div class="col-sm-12">
          <div class="">
            <form class="mt-3" [formGroup]="editQuoteForm">

              <div class="form-group">
                <label class="control-label" for="quote_status">Status</label>
                <select class="form-control" formControlName="quote_status" id="quote_status"
                  (change)="setQuoteStatus()" [attr.disabled]="!canEditStatus ? 'disabled' : null">
                  <option [ngValue]="null">Please select</option>
                  <option *ngFor="let status of quoteStatus" [ngValue]="status.id">{{ status.name }}</option>
                </select>
              </div>

              <ng-container *ngIf="isAdmin">
                <div class="row mb-2" *ngIf="selectedQuote">
                  <div class="col-sm-6">
                    <span>Current Allocated Sales Rep</span>
                  </div>
                  <div class="col-sm-6">
                    <span>{{ selectedQuote.quoteOwner }}</span>
                  </div>
                </div>

                <tan-loader [loading]="(salesRepsLoading$ | async)" [loadingText]="'<p>Loading Sales reps</p>'">
                </tan-loader>

                <div class="row justify-content-center" *ngIf="(salesRepsError$ | async)">
                  <div class="col-sm-12 d-flex justify-content-center">
                    <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Quote'">
                    </tan-alert-message>
                  </div>
                </div>

                <div class="form-group" *ngIf="!(salesRepsLoading$ | async) && !(salesRepsError$ | async)">
                  <label class="control-label" for="quote_owner">Change sales rep</label>
                  <select class="form-control" formControlName="quote_owner" id="quote_owner"
                    (change)="setQuoteOwner()">
                    <option [ngValue]="null">Please select</option>
                    <option *ngFor="let rep of salesReps" [ngValue]="rep.id">{{ rep.user.firstName }} 
                      {{ rep.user.lastName }}</option>
                  </select>
                </div>
              </ng-container>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal #editQuoteDismissModal [size]="'md'" [title]="'Edit Quote'" [showInformationBlock]="false"
  [showActionButton]="false">
  <div modal-content>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Cannot edit this quote'"></tan-alert-message>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal #noViewModal [size]="'md'" [title]="'Edit Quote'" [showInformationBlock]="false" [showActionButton]="false">
  <div modal-content>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Cannot view quote until Approved, or if cancelled'">
          </tan-alert-message>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal #duplicateModal [size]="'md'" [title]="'Duplicate Quote'" [showInformationBlock]="false"
  [showActionButton]="false">
  <div modal-content>
    <div class="container">

      <tan-loader [loading]="(quoteLoading$ | async)" [loadingText]="'<p>Getting Quote</p>'">
      </tan-loader>
      <tan-loader [loading]="(newRentalQuoteLoading$ | async)" [loadingText]="'<p>Duplicating Quote</p>'">
      </tan-loader>
      <tan-loader [loading]="(createLineItemLoading$ | async)" [loadingText]="'<p>Duplicating Line Items</p>'">
      </tan-loader>
      <tan-loader [loading]="(createProductConfigurationLoading$ | async)"
        [loadingText]="'<p>Duplicating Optional Extras</p>'">
      </tan-loader>
      <tan-loader [loading]="(newPurchaseQuoteLoading$ | async)" [loadingText]="'<p>Duplicating Quote</p>'">
      </tan-loader>
      <tan-loader [loading]="(createPurchaseLineItemLoading$ | async)" [loadingText]="'<p>Duplicating Line Items</p>'">
      </tan-loader>
      <tan-loader [loading]="(createProductConfigurationLoading$ | async)"
        [loadingText]="'<p>Duplicating Extras</p>'">
      </tan-loader>

      <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center">
          <ng-container *ngIf="quote && quote.lineItems && quote.lineItems.length == 0">
            <tan-alert-message [errorType]="'error'" [message]="'Can not duplicate blank Quote'">
            </tan-alert-message>
          </ng-container>
          <ng-container *ngIf="(quoteError$ | async)">
            <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Quote'">
            </tan-alert-message>
          </ng-container>
          <ng-container *ngIf="(newRentalQuoteError$ | async)">
            <tan-alert-message [errorType]="'error'" [message]="'Could not duplicate Quote'">
            </tan-alert-message>
          </ng-container>
          <ng-container *ngIf="(createLineItemError$ | async)">
            <tan-alert-message [errorType]="'error'" [message]="'Could not duplicate line items'">
            </tan-alert-message>
          </ng-container>
          <ng-container *ngIf="(createProductConfigurationError$ | async)">
            <tan-alert-message [errorType]="'error'" [message]="'Could not duplicate optional extras'">
            </tan-alert-message>
          </ng-container>
          <ng-container *ngIf="(newPurchaseQuoteError$ | async)">
            <tan-alert-message [errorType]="'error'" [message]="'Could not duplicate Quote'">
            </tan-alert-message>
          </ng-container>
          <ng-container *ngIf="(createPurchaseLineItemError$ | async)">
            <tan-alert-message [errorType]="'error'" [message]="'Could not duplicate line items'">
            </tan-alert-message>
          </ng-container>
          <ng-container *ngIf="(createProductConfigurationError$ | async)">
            <tan-alert-message [errorType]="'error'" [message]="'Could not duplicate extras'">
            </tan-alert-message>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</tan-modal>